var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customer-table-chat"},[_c('a',{class:{ enable: _vm.canChat },on:{"click":_vm.showChatBox}},[(_vm.canChat)?_c('img',{attrs:{"src":_vm.chatEnableImg}}):_c('img',{attrs:{"src":_vm.chatDisabledImg}})])])}
var staticRenderFns = []

export { render, staticRenderFns }